import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuItemUpdate } from '~/services/api/contracts/requests/MenuItemUpdate'

// UpdateMenuItemRequest
export const MenuItemUpdateByItem = (context: NoContext): ReturnType<typeof MenuItemUpdate> =>
  MenuItemUpdate(context)
